import React, { Component } from "react";
import { connect } from 'react-redux';
import Header from '../../components/home/header/header';
import Breadcrumb from '../../components/breadcrumb/breadcrumb';
import Footer from '../../components/home/footer/footer';
import ModalSearch from '../../components/modal-search/modal-search';
import ModalMenu from '../../components/modal-menu/modal-menu';
import Scrollup from '../../components/scroll-up/sroll-up';
import { beforeUser } from '../../components/user/user.action'
import { ENV } from '../../config/config'
const bannerImg = '/img/placeholder.png';

class Layout1 extends Component {
    state = {
        banner: null
    }
    componentDidMount() {
        const key = ENV.getUserKeys('_id');
        if (key._id) {
            let user = ENV.getUserKeys('');
            let banner = user.bannerImage ? user.bannerImage : '';
            this.setState({ banner })
        }
        if (window.location.href.split('/')[3] === "privacy-and-terms") {
            this.setState({ banner: null })
        }
    }
    componentDidUpdate() {
        if (this.props.collection.getAuth) {
            const { collection } = this.props.collection
            if (collection && collection.banner)
                this.setState({ banner: collection.banner })
            else
                this.setState({ banner: bannerImg })
            this.props.beforeUser()
        }
        if (this.props.user.individualUserAuth) {
            if (this.state.banner !== this.props.user.individualUser.bannerImage) {
                const user = this.props.user.individualUser
                if (user.bannerImage)
                    this.setState({ banner: user.bannerImage })
            }
        }
        if (this.props.user.bannerAuth) {
            this.setState({ banner: this.props.user.banner })
            this.props.beforeUser()
        }
    }
    render() {
        const { title } = this.props
        return (
            <div className="main">
                <Header />
                <Breadcrumb title={title} banner={this.state.banner || bannerImg} />
                {this.props.children}
                <Footer />
                <ModalSearch />
                <ModalMenu />
                <Scrollup />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    error: state.error,
    collection: state.collection,
    user: state.user,
});

export default connect(mapStateToProps, { beforeUser })(Layout1);